import { useFormik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Dropdown } from "primereact/dropdown";
import * as Yup from "yup";
import { InputText } from "primereact/inputtext";

import { InputNumber } from "primereact/inputnumber";

import { Button } from "primereact/button";
import { Country, State, City } from "country-state-city";
import { Divider } from "primereact/divider";
import { ColorPicker } from "primereact/colorpicker";
import { FileUpload } from "primereact/fileupload";

import { Image } from "primereact/image";

import {
  getSetupDetails,
  updateSetupDetails,
} from "../../store/AsyncMethods/SetupMethod";
import useSetupDetails from "../../hooks/useSetupDetails";
import { toast } from "react-toastify";

export default function SetupMain() {
  const dispatch = useDispatch();
  const countries = Country.getAllCountries();
  const [allStates, setStates] = useState([]);
  const [allCities, setCities] = useState([]);
  const [imageUrl, setImageUrl] = useState(null);
  const [image, setImage] = useState(null);
  let fileUploadRef = useRef(null);

  const navigate = useNavigate();
  const { setupDetails } = useSetupDetails();

  const onFileUpload = () => {
    if (fileUploadRef.current) {
      const inputElement = fileUploadRef.current.getInput();
      inputElement.click();
    }
  };

  const onFileSelect = (e) => {
    const file = e.files[0];

    if (!file) {
      toast.error("File is invalid or exceeding size");
      return;
    }

    if (file.type !== "image/png") {
      toast.error("Only PNG files are allowed");
      return;
    }

    setImageUrl(file);

    const url = URL.createObjectURL(file);
    setImage(url);
  };

  const styleOptions = [
    { name: "Italic", id: "italic" },
    { name: "Non italic", id: "not-italic" },
  ];

  useEffect(() => {
    if (setupDetails) {
      formik.setValues({
        name: setupDetails.name || "",
        email: setupDetails.email || "",
        regNo: setupDetails.reg_number || "12345",
        foundedYear: setupDetails.foundedYear || "2025",
        country: setupDetails.country || "",
        state: setupDetails.state || "",
        city: setupDetails.city || "",
        address: setupDetails.address || "",
        postalCode: setupDetails.postalCode || "",
        phone: setupDetails.phone || "03202020222",
        long: setupDetails.longi || "",
        lat: setupDetails.lat || "",
        colorPrimary: setupDetails.colorPrimary || "",
        colorSecondary: setupDetails.colorSecondary || "",
        fontStyle: setupDetails.fontStyle || "",
      });
    }
  }, [setupDetails]);

  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      regNo: "12345",
      foundedYear: "2025",
      country: "",
      state: "",
      city: "",
      address: "",
      postalCode: "",
      phone: "03003030300",
      long: "",
      lat: "",
      colorPrimary: "444444",
      colorSecondary: "454545",
      fontStyle: "",
      logo: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Name Required"),
      email: Yup.string().required("Email Required"),
      regNo: Yup.number().required("Registration No. Required"),
      foundedYear: Yup.number().required("Founded year Required"),
      country: Yup.string().required("Country Required"),
      state: Yup.string().required("State Required"),
      city: Yup.string().required("City Required"),
      address: Yup.string().required("Address Required"),
      postalCode: Yup.string().required("Postal Code Required"),
      phone: Yup.number().required("Phone Required"),
      long: Yup.string().required("Longitude Required"),
      lat: Yup.string().required("Latitude Required"),
      colorPrimary: Yup.string().required("Primary Color Required"),
      colorSecondary: Yup.string().required("Secondary Color Required"),
      fontStyle: Yup.string().required("Font Style Required"),
    }),

    onSubmit: async (data) => {
      const formData = new FormData();

      Object.keys(data).forEach((key) => {
        formData.append(key, data[key]);
      });

      if (imageUrl) {
        formData.append("image", imageUrl);
      }

      dispatch(updateSetupDetails(formData)).then((success) => {
        if (success) {
          formik.resetForm();
          dispatch(getSetupDetails());
          navigate("/site-setup");
        }
      });
    },
  });

  useEffect(() => {
    dispatch(getSetupDetails());
  }, []);
  useEffect(() => {
    setStates(State.getStatesOfCountry(formik.values.country));
  }, [formik.values.country]);
  useEffect(() => {
    setCities(
      City.getCitiesOfState(formik.values.country, formik.values.state)
    );
  }, [formik.values.state]);

  return (
    <div className="mx-4">
      <form onSubmit={formik.handleSubmit}>
        <div className="card shadow-md rounded-lg p-4 mt-3">
          <Divider>
            <span className="text-2xl font-bold p-font-style text-center text-primary mx-1">
              Company Details
            </span>
          </Divider>

          <div className="px-4 gap-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
            <div className="">
              <div className="flex flex-col gap-2">
                <label htmlFor="name" className="">
                  Name*
                </label>
                <span className=" w-full">
                  <InputText
                    id="name"
                    name="name"
                    maxLength={25}
                    className="w-full text-lg p-primary-input"
                    value={formik.values.name}
                    onChange={formik.handleChange}
                  />
                </span>
              </div>
              {formik.touched?.name && formik.errors?.name && (
                <div className="p-error">{formik.errors?.name}</div>
              )}
            </div>

            <div className="">
              <div className="flex flex-col gap-2">
                <label htmlFor="email" className="">
                  Email*
                </label>
                <span className=" w-full">
                  <InputText
                    id="email"
                    name="email"
                    maxLength={25}
                    className="w-full text-lg p-primary-input"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                  />
                </span>
              </div>
              {formik.touched?.email && formik.errors?.email && (
                <div className="p-error">{formik.errors?.email}</div>
              )}
            </div>

            <div className="">
              <div className="flex flex-col gap-2">
                <label htmlFor="regNo" className="">
                  Registration Number*
                </label>
                <span className=" w-full">
                  <InputNumber
                    id="regNo"
                    name="regNo"
                    maxLength={20}
                    useGrouping={false}
                    inputClassName="p-primary-input"
                    className="w-full text-lg p-primary-input"
                    value={formik.values.regNo}
                    onValueChange={formik.handleChange}
                  />
                </span>
              </div>
              {formik.touched?.regNo && formik.errors?.regNo && (
                <div className="p-error">{formik.errors?.regNo}</div>
              )}
            </div>

            <div className="">
              <div className="flex flex-col gap-2">
                <label htmlFor="foundedYear" className="">
                  Founded Year*
                </label>
                <span className=" w-full">
                  <InputNumber
                    id="foundedYear"
                    name="foundedYear"
                    maxLength={4}
                    useGrouping={false}
                    min={1900}
                    max={2100}
                    inputClassName="p-primary-input"
                    className="w-full text-lg p-primary-input"
                    value={formik.values.foundedYear}
                    onValueChange={formik.handleChange}
                  />
                </span>
              </div>
              {formik.touched?.foundedYear && formik.errors?.foundedYear && (
                <div className="p-error">{formik.errors?.foundedYear}</div>
              )}
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
          <div className="card shadow-md rounded-lg p-4 pt-1 mt-3">
            <Divider>
              <span className="text-2xl font-bold p-font-style text-center text-primary mx-1">
                Country Detail
              </span>
            </Divider>

            <div className="px-4 gap-4 grid grid-cols-1 lg:grid-cols-2">
              <div className="">
                <div className="flex flex-col gap-2">
                  <label htmlFor="country" className="">
                    Select Country*
                  </label>
                  <Dropdown
                    placeholder="Select"
                    id="country"
                    name="country"
                    maxLength={25}
                    className="!w-full text-lg p-primary-input"
                    value={formik.values.country}
                    onChange={formik.handleChange}
                    options={countries}
                    optionLabel="name"
                    optionValue="isoCode"
                    filter
                    pt={{
                      root: { className: "w-full" },
                      input: { className: "w-full p-primary-input" },
                      filterIcon: { className: "ml-1" },
                      filterInput: { className: "pl-6" },
                    }}
                  />
                </div>
                {formik.touched?.country && formik.errors?.country && (
                  <div className="p-error">{formik.errors?.country}</div>
                )}
              </div>

              <div className="">
                <div className="flex flex-col gap-2">
                  <label htmlFor="state" className="">
                    Select State*
                  </label>
                  <Dropdown
                    placeholder="Select"
                    id="state"
                    name="state"
                    maxLength={25}
                    className="!w-full text-lg p-primary-input"
                    value={formik.values.state}
                    onChange={formik.handleChange}
                    options={allStates}
                    optionLabel="name"
                    optionValue="isoCode"
                    filter
                    pt={{
                      root: { className: "w-full" },
                      input: { className: "w-full p-primary-input" },
                      filterIcon: { className: "ml-1" },
                      filterInput: { className: "pl-6" },
                    }}
                  />
                </div>
                {formik.touched?.state && formik.errors?.state && (
                  <div className="p-error">{formik.errors?.state}</div>
                )}
              </div>

              <div className="">
                <div className="flex flex-col gap-2">
                  <label htmlFor="city" className="">
                    Select City*
                  </label>
                  <Dropdown
                    placeholder="Select"
                    id="city"
                    name="city"
                    maxLength={25}
                    className="!w-full text-lg p-primary-input"
                    value={formik.values.city}
                    onChange={formik.handleChange}
                    options={allCities}
                    optionLabel="name"
                    optionValue="name"
                    filter
                    pt={{
                      root: { className: "w-full" },
                      input: { className: "w-full p-primary-input" },
                      filterIcon: { className: "ml-1" },
                      filterInput: { className: "pl-6" },
                    }}
                  />
                </div>
                {formik.touched?.city && formik.errors?.city && (
                  <div className="p-error">{formik.errors?.city}</div>
                )}
              </div>
            </div>

            <Divider>
              <span className="text-2xl font-bold p-font-style text-center text-primary mx-1">
                Contact Details
              </span>
            </Divider>

            <div className="px-4 gap-4 grid grid-cols-1 lg:grid-cols-2">
              <div className="">
                <div className="flex flex-col gap-2">
                  <label htmlFor="address" className="">
                    Address*
                  </label>
                  <span className=" w-full">
                    <InputText
                      id="address"
                      name="address"
                      maxLength={100}
                      className="w-full text-lg p-primary-input"
                      value={formik.values.address}
                      onChange={formik.handleChange}
                    />
                  </span>
                </div>
                {formik.touched?.address && formik.errors?.address && (
                  <div className="p-error">{formik.errors?.address}</div>
                )}
              </div>

              <div className="">
                <div className="flex flex-col gap-2">
                  <label htmlFor="postalCode" className="">
                    Postal code*
                  </label>
                  <span className=" w-full">
                    <InputText
                      id="postalCode"
                      name="postalCode"
                      maxLength={20}
                      className="w-full text-lg p-primary-input"
                      value={formik.values.postalCode}
                      onChange={formik.handleChange}
                    />
                  </span>
                </div>
                {formik.touched?.postalCode && formik.errors?.postalCode && (
                  <div className="p-error">{formik.errors?.postalCode}</div>
                )}
              </div>

              <div className="">
                <div className="flex flex-col gap-2">
                  <label htmlFor="phone" className="">
                    Phone*
                  </label>
                  <span className=" w-full">
                    <InputText
                      id="phone"
                      name="phone"
                      maxLength={20}
                      inputClassName="p-primary-input"
                      className="w-full text-lg p-primary-input"
                      value={formik.values.phone}
                      onChange={formik.handleChange}
                    />
                  </span>
                </div>
                {formik.touched?.phone && formik.errors?.phone && (
                  <div className="p-error">{formik.errors?.phone}</div>
                )}
              </div>

              <div className="flex justify-between gap-2">
                <div className="flex flex-col w-full gap-2">
                  <label htmlFor="long" className="">
                    Longitude*
                  </label>
                  <span className=" w-full">
                    <InputText
                      id="long"
                      name="long"
                      maxLength={30}
                      className="w-full text-lg p-primary-input"
                      value={formik.values.long}
                      onChange={formik.handleChange}
                    />
                  </span>
                </div>
                {formik.touched?.long && formik.errors?.long && (
                  <div className="p-error">{formik.errors?.long}</div>
                )}
                <div className="flex flex-col w-full gap-2">
                  <label htmlFor="lat" className="">
                    Latitude*
                  </label>
                  <span className=" w-full">
                    <InputText
                      id="lat"
                      name="lat"
                      maxLength={30}
                      className="w-full text-lg p-primary-input"
                      value={formik.values.lat}
                      onChange={formik.handleChange}
                    />
                  </span>
                </div>
                {formik.touched?.lat && formik.errors?.lat && (
                  <div className="p-error">{formik.errors?.lat}</div>
                )}
              </div>
            </div>
          </div>
          <div className="card shadow-md rounded-lg p-4 pt-1 mt-3">
            <Divider>
              <span className="text-2xl font-bold p-font-style text-center text-primary mx-1">
                Design Customization
              </span>
            </Divider>

            <div className="px-4 gap-4 grid grid-cols-1 lg:grid-cols-2">
              <div className="">
                <div className="flex flex-col gap-2">
                  <label htmlFor="colorPrimary" className="">
                    Primary Color
                  </label>
                  <span className="flex  w-full gap-2">
                    <InputText
                      id="colorPrimary"
                      name="colorPrimary"
                      maxLength={6}
                      className="w-full text-lg p-primary-input"
                      value={formik.values.colorPrimary}
                      onChange={formik.handleChange}
                    />
                    <div className="p-colorpicker-container   flex ">
                      <ColorPicker
                        id="colorPrimary"
                        format="hex"
                        value={formik.values.colorPrimary}
                        onChange={formik.handleChange}
                        inline={false}
                      />
                    </div>
                  </span>
                  <small id="colorPrimary-help">
                    Enter your color in HEX format (e.g., 1A2B3C)
                  </small>
                </div>
                {formik.touched?.colorPrimary &&
                  formik.errors?.colorPrimary && (
                    <div className="p-error">{formik.errors?.colorPrimary}</div>
                  )}
              </div>

              <div className="">
                <div className=" flex flex-col gap-2">
                  <label htmlFor="colorSecondary" className="">
                    Secondary Color
                  </label>
                  <span className="flex  w-full gap-2">
                    <InputText
                      id="colorSecondary"
                      name="colorSecondary"
                      maxLength={6}
                      className="w-full text-lg p-primary-input"
                      value={formik.values.colorSecondary}
                      onChange={formik.handleChange}
                    />
                    <div className=" p-colorpicker-container flex">
                      <ColorPicker
                        id="colorSecondary"
                        format="hex"
                        value={formik.values.colorSecondary}
                        onChange={formik.handleChange}
                        inline={false}
                      />
                    </div>
                  </span>
                  <small id="colorSecondary-help">
                    Enter your color in HEX format (e.g., 1A2B3C)
                  </small>
                </div>
                {formik.touched?.colorSecondary &&
                  formik.errors?.colorSecondary && (
                    <div className="p-error">
                      {formik.errors?.colorSecondary}
                    </div>
                  )}
              </div>

              <div className="">
                <div className="flex flex-col gap-2">
                  <label htmlFor="fontStyle" className="">
                    Font Style
                  </label>
                  <span className="flex  w-full gap-2">
                    <Dropdown
                      id="fontStyle"
                      name="fontStyle"
                      className="w-full text-lg p-primary-input"
                      value={formik.values.fontStyle}
                      onChange={formik.handleChange}
                      options={styleOptions}
                      optionLabel="name"
                      optionValue="id"
                      pt={{
                        root: { className: "w-full" },
                        input: { className: "w-full p-primary-input" },
                        filterIcon: { className: "ml-2" },
                        filterInput: { className: "pl-8" },
                      }}
                    />
                  </span>
                </div>
                {formik.touched?.fontStyle && formik.errors?.fontStyle && (
                  <div className="p-error">{formik.errors?.fontStyle}</div>
                )}
              </div>
              <div className="">
                <div className="flex flex-col gap-2">
                  <label htmlFor="logo" className="">
                    Company Logo
                  </label>
                  <div className=" flex flex-col gap-2">
                    <Button
                      onClick={onFileUpload}
                      type="button"
                      label="Upload"
                      icon="pi pi-plus"
                      className="  p-primary-highlight-btn"
                    />

                    <FileUpload
                      ref={fileUploadRef}
                      mode="basic"
                      name="logo-upload"
                      url="/api/upload"
                      accept="image/png"
                      maxFileSize={1000000}
                      auto
                      onSelect={onFileSelect}
                      style={{ display: "none" }}
                    />
                    <small id="logo-upload-help">
                      Please upload a PNG file smaller than 1MB.
                    </small>
                    <div className="flex justify-end">
                      {image ? (
                        <Image
                          src={image}
                          alt="Uploaded Logo"
                          width="128"
                          height="128"
                          preview
                        />
                      ) : (
                        setupDetails?.logo && (
                          <Image
                            src={setupDetails.logoPath + setupDetails.logo}
                            alt="Uploaded Logo"
                            width="128"
                            height="128"
                            preview
                          />
                        )
                      )}
                    </div>
                  </div>
                </div>
                {formik.touched?.logo && formik.errors?.logo && (
                  <div className="p-error">{formik.errors?.logo}</div>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="mt-8">
          <div className="flex justify-end gap-4">
            <Button
              label="Clear"
              icon="pi pi-times"
              className="p-red-btn"
              type="button"
              onClick={() => {
                formik.resetForm();
              }}
            />
            <Button
              type="submit"
              label="Save"
              icon="pi pi-check"
              className="p-secondary-btn"
            />
          </div>
        </div>
      </form>
    </div>
  );
}
